var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.4014 18.1227C29.6913 18.1227 29.9262 17.8877 29.9262 17.5979V6.02341C29.9262 4.96049 29.0617 4.0959 27.9987 4.0959H26.2364V3.34674C26.2365 2.5489 25.5875 1.9 24.7897 1.9H24.7165C23.9186 1.9 23.2697 2.5489 23.2697 3.34674V4.0959H15.1053C14.8154 4.0959 14.5805 4.33088 14.5805 4.62071C14.5805 4.91053 14.8154 5.14551 15.1053 5.14551H23.2697V6.52955C23.2697 7.32734 23.9186 7.97624 24.7165 7.97624H24.7897C25.5875 7.97624 26.2364 7.32734 26.2364 6.52955V5.14551H27.9987C28.4827 5.14551 28.8766 5.53942 28.8766 6.02341V9.7483H3.94961V6.02341C3.94961 5.53942 4.34352 5.14551 4.82751 5.14551H6.58985V6.52955C6.58985 7.32734 7.23875 7.97624 8.03654 7.97624H8.10978C8.90756 7.97624 9.55646 7.32734 9.55646 6.52955V5.14551H13.406C13.6959 5.14551 13.9308 4.91053 13.9308 4.62071C13.9308 4.33088 13.6959 4.0959 13.406 4.0959H9.55646V3.34674C9.55646 2.5489 8.90757 1.9 8.10978 1.9H8.03654C7.23875 1.9 6.58985 2.5489 6.58985 3.34674V4.0959H4.82751C3.76459 4.0959 2.9 4.96049 2.9 6.02341V29.0459C2.9 30.1786 3.8214 31.1 4.9541 31.1H27.8721C29.0048 31.1 29.9262 30.1786 29.9262 29.0459V19.2971C29.9262 19.0073 29.6913 18.7723 29.4014 18.7723C29.1115 18.7723 28.8766 19.0073 28.8766 19.2971V29.0459C28.8766 29.5997 28.4259 30.0504 27.8721 30.0504H4.9541C4.40033 30.0504 3.94961 29.5997 3.94961 29.0459V10.7978H28.8766V17.5979C28.8766 17.8877 29.1115 18.1227 29.4014 18.1227ZM25.1868 6.52955C25.1868 6.7484 25.0086 6.92663 24.7898 6.92663H24.7165C24.4976 6.92663 24.3194 6.7484 24.3194 6.52955V3.34674C24.3194 3.12789 24.4977 2.94961 24.7165 2.94961H24.7898C25.0086 2.94961 25.1868 3.12787 25.1868 3.34674V6.52955ZM7.63946 3.34674C7.63946 3.12788 7.81775 2.94961 8.03654 2.94961H8.10978C8.32862 2.94961 8.50686 3.12787 8.50686 3.34674V6.52955C8.50686 6.7484 8.32858 6.92663 8.10978 6.92663H8.03654C7.81769 6.92663 7.63946 6.74841 7.63946 6.52955V3.34674Z",
    fill: "#CD8F6C",
    stroke: "#CD8F6C",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 233"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 42",
    x: 7.5,
    y: 14.5,
    width: 3.72727,
    height: 3.72727,
    rx: 0.5,
    fill: "#CD8F6C",
    stroke: "#CD8F6C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 45",
    x: 7.5,
    y: 22.7734,
    width: 3.72727,
    height: 3.72727,
    rx: 0.5,
    stroke: "#CD8F6C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 43",
    x: 14.5908,
    y: 14.5,
    width: 3.72727,
    height: 3.72727,
    rx: 0.5,
    stroke: "#CD8F6C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 46",
    x: 14.5908,
    y: 22.7734,
    width: 3.72727,
    height: 3.72727,
    rx: 0.5,
    stroke: "#CD8F6C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 44",
    x: 21.6816,
    y: 14.5,
    width: 3.72727,
    height: 3.72727,
    rx: 0.5,
    stroke: "#CD8F6C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 47",
    x: 21.6816,
    y: 22.7734,
    width: 3.72727,
    height: 3.72727,
    rx: 0.5,
    stroke: "#CD8F6C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.8212ccac65ec694ba64591eba1ff625f.svg";
export { ForwardRef as ReactComponent };